import React, { useState } from "react";
import style from "./navbar.module.css";
import { Link, useLocation } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";

const Navbar = () => {
  const location = useLocation();

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  const handleMenuItemClick = () => {
    setIsNavCollapsed(true);
  };

  return (
    <nav className="navbar p-0 navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid ps-0 pe-0">
        <button
          className={`navbar-toggler ${style.navbar_toggle_btn}`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          {isNavCollapsed ? (
            <span
              className={`navbar-toggler-icon ${style.nav_toggle_toggle_icon}`}
            />
          ) : (
            <span className={`${style.toggle_cross_icon}`}>
              <RxCross1 />
            </span> // You can replace this with your cross icon or image
          )}
        </button>
        <div
          className={`${style.navbar_main} ${
            isNavCollapsed ? "collapse" : ""
          } navbar-collapse`}
          id="navbarSupportedContent"
        >
          <ul className={`${style.navbar_ul_list} navbar-nav  mb-2 mb-lg-0`}>
            <Link
              to="/"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                Home
              </li>
            </Link>
            <Link
              to="/about"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/about"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                About
              </li>
            </Link>
            <Link
              to="/schemes"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/schemes"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                Schemes
              </li>
            </Link>
            <Link
              to="/gpt_members"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/gpt_members"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                grampanchayat members
              </li>
            </Link>
            <Link
              to="/imp-places"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/imp-places"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                important places
              </li>
            </Link>
            <Link
              to="/social-works"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/social-works"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                social work
              </li>
            </Link>
            <Link
              to="/emergency-contact"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/emergency-contact"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                emergency contact
              </li>
            </Link>
            <Link
              to="/contact"
              className={`nav-link ${style.nav_links}`}
              aria-current="page"
              onClick={handleMenuItemClick}
            >
              <li
                className={
                  location.pathname === "/contact"
                    ? `nav-item ${style.nav_li_active} ${style.nav_li}`
                    : `${style.nav_li}`
                }
              >
                contact
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
